import { useCallback, useEffect, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { connect, useDispatch } from "react-redux";
import { getWidgets, getWidget, deleteWidget } from "../../../../../action/masters/widgetActionCreator";
import { baseURL } from "../../../../../constants/commonConstants";
import { alertConstants, getAlertData } from "../../../../../helper/sweet-alert";
import { IwidgetIndex, IWidgetData } from "../../../../../models/master/widgets";
import { setWidgets } from "../../../../../store/slices/master/widgetSlice";
import WidgetCreate from "./widgetCreate";
import WidgetEdit from "./widgetEdit";
import ReactModal from "react-modal";
import LoaderSpinner from "../../../../../common-components/loader";
import FloatingLabelDropDown from "../../../../../common-components/floatingdropdown";
import { sortAlphabetically } from "../../../../../common-functions/commonFunctions";
import { getUserTypes } from "../../../../../action/common/commonActionCreator";
import { UserTypes } from "../../../../../models/dashboard/adminDashboard";

const WidgetsIndex = (props: IwidgetIndex) => {
  const { getWidgets, widgets, getWidget, widget, deleteWidget, userTypes, getUserTypes } = props;
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const [selectedUserType, setSelectedUserType] = useState<number | null>(null);
  const dispatch = useDispatch();

  const handleCreateOpen = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  const editItem = async (id: number) => {
    handleEditOpen();
    setIsEditLoading(true);
    try {
      await getWidget(id);
    } finally {
      setIsEditLoading(false);
    }
  };

  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      setShowAlert(false);
      setIsDelete(false);
      deleteWidget(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getAllWidgets(selectedUserType ?? undefined);
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllWidgets = async (userType?: number) => {
    setIsLoading(true);
    try {
      await getWidgets(userType);
    } finally {
      setIsLoading(false);
    }
  };

  const onUserTypeChange = useCallback((e: any) => {
    if (e.target.name == "userType")
      setSelectedUserType(e.target.value)
    getAllWidgets(e.target.value)
  }, [])

  useEffect(() => {
    getAllWidgets();
    getUserTypes();
    return () => {
      dispatch(setWidgets([]));
    };
  }, []);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Widgets</h2>
          <div className="side-filter">
            <div className="justify-content-left">
            <FloatingLabelDropDown
              label=""
              placeholder="-Select UserType-"
              onChange={(e: any) => onUserTypeChange(e)}
              isMandatory={false}
              value={selectedUserType}
              name="userType"
              optionsList={sortAlphabetically(
                userTypes?.filter((type) => type.id !== UserTypes.Freshman)
              )}
            />
          </div>
          <a
            href="javascript:void(0)"
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#addnewbuttons"
            onClick={() => {
              handleCreateOpen();
            }}
          >
            <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
            Add New
          </a>
        </div>
        </div>

        <ul className="d-flex gap-3 flex-wrap mt-28">
          {isLoading ? (
            <LoaderSpinner />
          ) : widgets && widgets.length > 0 ? (
            widgets.map((widget: IWidgetData) => {
              return (
                <li
                  className="admin-card"
                  style={{
                    pointerEvents: !widget.isActive ? "none" : "auto",
                    opacity: !widget.isActive ? 0.5 : 1,
                  }}
                >
                  <div className="top">
                    <div className="btn-flex">
                      <button
                        className="btn-edit"
                        onClick={() => editItem(widget.id ?? 0)}
                      >
                        <img src="/assets/images/icon/edit-wh.svg" alt="" />
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteItem(widget.id ?? 0)}
                      >
                        <img src="/assets/images/icon/trash-wh.svg" alt="" />
                      </button>
                    </div>
                  </div>
                  <a href={widget.url} target="_blank">
                    <div className="btm">
                      <div className="img">
                        <img src={widget.image ? baseURL + widget.image : ""} />
                      </div>
                      <h2>{widget.name}</h2>
                      <p className="para-hide-1">{widget.description}</p>
                    </div>
                  </a>
                </li>
              );
            })
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
        <ReactModal
          isOpen={showCreate}
          onRequestClose={handleCreateClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
          shouldCloseOnOverlayClick={false}
        >
          <WidgetCreate
            setShowCreate={handleCreateClose}
            getAllWidgets={() => getAllWidgets(selectedUserType ?? undefined)}
          />
        </ReactModal>
        {isEditLoading ? (
          <LoaderSpinner />
        ) : (
          <ReactModal
            isOpen={showEdit}
            onRequestClose={handleEditClose}
            className="react-modal-content"
            overlayClassName="react-modal-overlay"
            shouldCloseOnOverlayClick={false}
          >
            <WidgetEdit
              widget={widget}
              setShowEdit={handleEditClose}
              getAllWidgets={() => getAllWidgets(selectedUserType ?? undefined)}
            />
          </ReactModal>
        )}

        <SweetAlert
          show={showAlert}
          success={false}
          type={alertType}
          title={alertTitle}
          onConfirm={() => onConfirm()}
          showCancel={isDelete}
          onCancel={() => {
            setShowAlert(false);
            setIsDelete(false);
          }}
          cancelBtnText={"No"}
          confirmBtnText={isDelete ? "Yes" : "Ok"}
        />
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getWidgets: (userType?:number) => getWidgets(userType),
  getWidget: (id: number) => getWidget(id),
  deleteWidget: (id: number, callBack: Function) => deleteWidget(id, callBack),
  getUserTypes: () => getUserTypes(),
};

function mapStateToProps(state: any) {
  return {
    widgets: state.widget.widgets,
    widget: state.widget.widget,
    userTypes: state.common.userTypes,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WidgetsIndex);